import { selectUsersManagement, type UsersManagement } from '../../../domain'
import { Usecase } from '..'

export abstract class UserManagementUsecase extends Usecase {
    setUsersManagement (changes: Partial<UsersManagement>): void {
        this.setState({ usersManagement: { ...selectUsersManagement(this.getState()), ...changes } })
    }
}
